'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../unsupportedIterableToArray-f175acfa.js');
var styles_breakpoints = require('../../breakpoints-ee0a4ae5.js');
var components_GlobalStyle_GlobalStyle = require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
var styles_theme = require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var requireImageFunctionDefault = function requireImageFunctionDefault(imageSource) {
  return imageSource;
};
var NuDsContext = /*#__PURE__*/React.createContext({
  locale: '',
  formatMessage: function formatMessage(_ref) {
    var id = _ref.id;
    return id;
  },
  routerLinkComponent: undefined,
  backgroundImageFunction: undefined,
  requireImageFunction: requireImageFunctionDefault
});
var defaultPrimaryColorScheme = 'brand';

function NuDSProvider(_ref2) {
  var locale = _ref2.locale,
      formatMessage = _ref2.formatMessage,
      messages = _ref2.messages,
      routerLinkComponent = _ref2.routerLinkComponent,
      theme = _ref2.theme,
      colorScheme = _ref2.colorScheme,
      children = _ref2.children,
      requireImageFunction = _ref2.requireImageFunction,
      backgroundImageFunction = _ref2.backgroundImageFunction;

  var nuDSUpdatedTheme = _extends._extends_1({}, theme, {
    colors: _extends._extends_1({}, theme.colors, {
      primary: theme.colors[colorScheme]
    })
  });

  return /*#__PURE__*/React__default['default'].createElement(React.StrictMode, null, /*#__PURE__*/React__default['default'].createElement(NuDsContext.Provider, {
    value: {
      locale: locale,
      formatMessage: formatMessage,
      messages: messages,
      routerLinkComponent: routerLinkComponent,
      requireImageFunction: requireImageFunction,
      backgroundImageFunction: backgroundImageFunction
    }
  }, /*#__PURE__*/React__default['default'].createElement(styled.ThemeProvider, {
    theme: nuDSUpdatedTheme
  }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(components_GlobalStyle_GlobalStyle.GlobalFonts, null), /*#__PURE__*/React__default['default'].createElement(components_GlobalStyle_GlobalStyle['default'], null), children, /*#__PURE__*/React__default['default'].createElement("div", {
    id: "modal-root"
  })))));
}

var nuDSProviderShape = {
  backgroundImageFunction: index.propTypes.func,
  children: index.propTypes.node.isRequired,
  colorScheme: index.propTypes.oneOf([].concat(styles_breakpoints.toConsumableArray(Object.keys(styles_theme.products)), [defaultPrimaryColorScheme])),
  formatMessage: index.propTypes.func,
  locale: index.propTypes.string,
  messages: index.propTypes.objectOf(index.propTypes.string),
  requireImageFunction: index.propTypes.func,

  /** The component to be rendered when the href will be an internal path */
  routerLinkComponent: index.propTypes.elementType,
  theme: index.propTypes.objectOf(index.propTypes.any)
};
NuDSProvider.propTypes = nuDSProviderShape;
NuDSProvider.defaultProps = {
  backgroundImageFunction: undefined,
  routerLinkComponent: undefined,
  theme: styles_theme.theme,
  colorScheme: defaultPrimaryColorScheme,
  formatMessage: function formatMessage() {},
  requireImageFunction: requireImageFunctionDefault,
  locale: undefined,
  messages: {}
};

exports.NuDsContext = NuDsContext;
exports.default = NuDSProvider;
exports.defaultPrimaryColorScheme = defaultPrimaryColorScheme;
exports.nuDSProviderShape = nuDSProviderShape;
exports.requireImageFunctionDefault = requireImageFunctionDefault;
//# sourceMappingURL=NuDSProvider.js.map
